////
/// ============================================================================
/// COMPONENT / Codyhouse Modal Video
/// ============================================================================
///
/// @group components
////

import ModalVideo from "./codyhouse/modal-video";
import ModalWindow from "./codyhouse/modal-window";

export default () => {
    ModalVideo();
    ModalWindow();
};
